import INTERFACE from "../setting/interface_pptx"

export default function buildSettingPptx() {
  let ret = {};
  ret.type = "pptx";
  ret.pref = "";
  ret.municipality = "";
  ret.font = "standard";
  ret.contents = buildSettingForContents(INTERFACE);
  return ret;
}

function buildSettingForContents(contents) {
  let ret = {};

  contents.forEach((item) => {
    ret[item.path] = true;
  })

  return ret;
}

